export enum ManualFeeState {
    Placeholder = 0,
    Posted = 1,
}
